import { ConditionalWrapper } from '@/hoc';
import { NextLink, Picture } from '@/atoms';

import { removeBaseURL } from '@/lib/utils';

import type { TypeBannerUltraSlimProps } from './types';

const BannerUltraSlim = ({
  baseImage,
  link,
  srcSet,
  fullWidth,
}: TypeBannerUltraSlimProps) => (
  <ConditionalWrapper
    condition={Boolean(link?.url)}
    wrapper={(c) => (
      <NextLink href={removeBaseURL(link?.url ?? '/')}>
        <a>{c}</a>
      </NextLink>
    )}
  >
    <Picture
      sources={[
        ...(srcSet?.map((source) => ({
          media: source.width,
          src: source.image.sourceUrl,
          width: source.image.mediaDetails.width,
          height: source.image.mediaDetails.height,
        })) || []),
        ...(baseImage && baseImage.sourceUrl
          ? [
              {
                src: baseImage.sourceUrl,
                width: baseImage.mediaDetails.width,
                height: baseImage.mediaDetails.height,
              },
            ]
          : []),
      ]}
      alt={baseImage?.altText ?? ''}
      sizes="100vw"
      classNameImg={`mx-auto object-cover object-center ${fullWidth ? 'w-full' : ''}`}
    />
  </ConditionalWrapper>
);

export { BannerUltraSlim };
